module.exports = __webpack_public_path__ + "static/media/login-bg.a1765080.png";